var _defs, _rect, _circle, _circle2, _circle3, _circle4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _text, _g8, _g9, _g0, _g1, _g10, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRateArtistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ra-iconClip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 43
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ra-bgGrad",
    cx: "40%",
    cy: "35%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c2fd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#4a0090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e003a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ra-rockGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c17d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#9a5c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6b3a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ra-rockFace",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d4966a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#b06e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7a4520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ra-rockHighlight",
    x1: "0%",
    y1: "0%",
    x2: "60%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e8b080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#c07840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8a4e22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ra-starFull",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff6a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff3d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ra-starHalf",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff6a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ff6a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ra-starGlow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ra-boltGlow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ra-rockShadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 4,
    stdDeviation: 4,
    floodColor: "#000",
    floodOpacity: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ra-noteGlow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ra-iconClip)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 22,
    fill: "url(#ra-bgGrad)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 22,
    r: 1.2,
    fill: "#ff6a00",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0.1;0.6",
    dur: "2.3s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 28,
    r: 1,
    fill: "#a855f7",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0.1;0.5",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 172,
    r: 1.3,
    fill: "#ff6a00",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;0.1;0.4",
    dur: "2.6s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 168,
    r: 1,
    fill: "#c084fc",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0.15;0.5",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ra-boltGlow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "158,22 153,40 160,38 155,55 168,34 160,37",
    fill: "#ff6a00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.9s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ra-boltGlow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "38,118 33,134 40,132 35,148 47,127 39,130",
    fill: "#ff6a00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "2.2s",
    begin: "1.1s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,42 L31.5,46 L36,46 L32.5,48.5 L34,53 L30,50 L26,53 L27.5,48.5 L24,46 L28.5,46 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.85;0.2;0.85",
    dur: "2.4s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,85 L179,88 L182,88 L179.5,90 L180.5,93 L178,91.5 L175.5,93 L176.5,90 L174,88 L177,88 Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0.15;0.8",
    dur: "1.9s",
    begin: "0.7s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#1a0840",
    filter: "url(#ra-noteGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 75,
    r: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 62,
    width: 2.5,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 62,
    width: 9,
    height: 2.5
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.4;1",
    dur: "2.1s",
    repeatCount: "indefinite",
    attributeType: "XML"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ra-noteGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 118,
    r: 5,
    fill: "#1a0840"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 105,
    width: 2.5,
    height: 13,
    fill: "#1a0840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.5,105 L192,108 L183.5,112 Z",
    fill: "#ff6a00"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.4;1",
    dur: "2.1s",
    begin: "1.05s",
    repeatCount: "indefinite",
    attributeType: "XML"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ra-rockShadow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "45,100 35,75 50,55 75,45 125,43 152,52 168,70 165,98 152,118 125,128 72,130 48,120",
    fill: "url(#ra-rockGrad)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50,55 75,45 125,43 152,52 145,62 110,58 75,60 55,65",
    fill: "url(#ra-rockHighlight)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45,100 35,75 50,55 55,65 48,85",
    fill: "#7a4520"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152,118 165,98 168,70 162,80 158,108",
    fill: "#6b3a1a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75,60 110,58 145,62 148,75 118,78 78,76 55,70 55,65",
    fill: "url(#ra-rockFace)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 65,
    x2: 55,
    y2: 120,
    stroke: "#5a3010",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 60,
    x2: 72,
    y2: 128,
    stroke: "#5a3010",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 62,
    x2: 148,
    y2: 120,
    stroke: "#5a3010",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 58,
    x2: 110,
    y2: 128,
    stroke: "#5a3010",
    strokeWidth: 0.8,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45,100 35,75 50,55 75,45 125,43 152,52 168,70 165,98 152,118 125,128 72,130 48,120",
    fill: "none",
    stroke: "#5a3010",
    strokeWidth: 1.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 73,
    textAnchor: "middle",
    fontFamily: "Arial Black, sans-serif",
    fontSize: 11,
    fontWeight: 900,
    letterSpacing: 2,
    fill: "#ffcc00",
    filter: "url(#ra-starGlow)"
  }, "ROCKSTAR")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ra-starGlow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "57,92 59,86 61,92 67,92 62,96 64,102 59,98 54,102 56,96 51,92",
    fill: "url(#ra-starFull)",
    stroke: "white",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.7;1",
    dur: "1.5s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ra-starGlow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80,90 82,84 84,90 90,90 85,94 87,100 82,96 77,100 79,94 74,90",
    fill: "url(#ra-starFull)",
    stroke: "white",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.7;1",
    dur: "1.5s",
    begin: "0.3s",
    repeatCount: "indefinite"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ra-starGlow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "103,88 105,82 107,88 113,88 108,92 110,98 105,94 100,98 102,92 97,88",
    fill: "url(#ra-starFull)",
    stroke: "white",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.7;1",
    dur: "1.5s",
    begin: "0.6s",
    repeatCount: "indefinite"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ra-starGlow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "126,90 128,84 130,90 136,90 131,94 133,100 128,96 123,100 125,94 120,90",
    fill: "url(#ra-starFull)",
    stroke: "white",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.7;1",
    dur: "1.5s",
    begin: "0.9s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ra-starGlow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "149,92 151,86 153,92 159,92 154,96 156,102 151,98 146,102 148,96 143,92",
    fill: "#777777",
    stroke: "white",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ra-halfClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 82,
    width: 8,
    height: 22
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "149,92 151,86 153,92 159,92 154,96 156,102 151,98 146,102 148,96 143,92",
    fill: "url(#ra-starFull)",
    clipPath: "url(#ra-halfClip)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.7;1",
    dur: "1.5s",
    begin: "1.2s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 160,
    textAnchor: "middle",
    fontFamily: "Arial Black, sans-serif",
    fontSize: 13,
    fontWeight: 900,
    letterSpacing: 0.5,
    fill: "#ffffff",
    style: {
      textShadow: "0 0 8px rgba(255,106,0,0.8)"
    }
  }, "\n    RATE THE ARTIST\n  ")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 1.6,
    width: 196.9,
    height: 196.9,
    rx: 43,
    fill: "none",
    stroke: "white",
    strokeWidth: 5.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateArtistIcon);
export default __webpack_public_path__ + "static/media/rate-artist-icon.848c68a5e272be33426a3f7cbf18022c.svg";
export { ForwardRef as ReactComponent };